<template>
  <div class="image-editor-container">
    <!-- Desktop header only -->
    <div class="uyh-customize-header" v-if="windowWidth >= 1024">
      <p>{{ $t('editor_tools.headers.customize_it') }}</p>
    </div>

    <!-- Tabs -->
    <div class="uyh-edit-tabs">
      <button :title="$t('editor_tools.buttons.edit_text_area')" class="image-edit js-tab active" @click="changeTab('image-editor')">
        <span class="box"></span>
      </button>
      <button :title="$t('editor_tools.buttons.edit_text_area')" class="text-edit js-tab" @click="changeTab('text-editor')">T</button>
      <button :title="$t('editor_tools.buttons.edit_background_area')" class="background-edit js-tab" @click="changeTab('background-editor')">
        <span class="box"></span>
      </button>
    </div>


    <!-- Image editor -->
    <div v-if="windowWidth >= 1024" class="image-editor active js-tab-group">
      <Option v-for="option in getStore.options"
              :key="$t('editor_tools.headers.' + option)"
              :option = option
              :type ="'image'"
              @scale-change="handleScale"
              @horizontal-move="handleHoriz"
              @vertical-move="handleVert"
              @enable-reset="$emit('enable-reset')"/>
    </div>
    <!-- Text editor -->
    <div v-if="windowWidth >= 1024" class="text-editor js-tab-group">
      <Option v-for="option in getStore.options"
              :key="$t('editor_tools.headers.' + option)"
              :option = option
              :type ="'text'"
              @enable-reset="$emit('enable-reset')"/>
    </div>
    <!-- Background editor -->
    <div v-if="windowWidth >= 1024" class="background-editor js-tab-group">
      <Option v-for="option in getStore.options"
              :key="$t('editor_tools.headers.' + option)"
              :option = option
              :type ="'background'"
              @enable-reset="$emit('enable-reset')"/>
    </div>
    <!-- Mobile slider -->
    <div v-if="windowWidth <= 1023" class="mobile-slider-wrapper">
      <div class="mobile-slider">
        <Option v-for="option in getStore.options"
                :key="$t('editor_tools.headers.' + option)"
                :option = option
                :type ="'mobile'"
                @scale-change="handleScale"
                @horizontal-move="handleHoriz"
                @vertical-move="handleVert"
                @enable-reset="$emit('enable-reset')"/>
      </div>
      <button class="prevStep"><svg svg-inline="" role="presentation" focusable="false" width="19" height="30" viewBox="0 0 19 30" xmlns="http://www.w3.org/2000/svg"><path d="M15.882 30L0 15 15.882 0l3.065 2.896L6.131 15l12.816 12.103z" fill="#21362C" fill-rule="evenodd"/></svg></button>
      <button class="nextStep"><svg svg-inline="" role="presentation" focusable="false" width="19" height="30" viewBox="0 0 19 30" xmlns="http://www.w3.org/2000/svg"><path d="M15.882 30L0 15 15.882 0l3.065 2.896L6.131 15l12.816 12.103z" fill="#21362C" fill-rule="evenodd"/></svg></button>
    </div>

    <div class="uyh-additional-controls" v-if="windowWidth <= 1023">
      <div tabindex="0" @click="$emit('reset')" class="resetMantra" :class='{disabled: resetStatus}'>{{ $t('navigation.reset') }}</div>
      <button @click="emitEvents" class="uyh-btn">{{ $t('navigation.next') }}</button>
    </div>
  </div>
</template>

<script>
  import Option from './Image_Option.vue';

  export default {
    props: ['resetStatus'],
    data: function() {
      return {
        windowWidth: 0
      }
    },
    components: {
      Option
    },
    methods: {
      handleScale: function(val) {
        this.$emit('scale-change', val);
      },
      handleVert: function(val) {
        this.$emit('vertical-move', val);
      },
      handleHoriz: function(val) {
        this.$emit('horizontal-move', val);
      },
      widowWidthFunction: function() {
        this.windowWidth = window.innerWidth;
      },
      emitEvents: function() {
        this.$emit('screenshot');
        this.$emit('loader-active');
      },
      changeTab: function(tabClass) {
        var currentTab = document.querySelector('.' + tabClass.split('or')[0]);
        if (window.innerWidth >= 1024) {
          var tabGroups = document.querySelectorAll('.js-tab-group');
          var tabButtons = document.querySelectorAll('.js-tab');
          var clickedButtonGroup = document.getElementsByClassName(tabClass)[0];
          currentTab.blur();

          for (var i=0; i<tabGroups.length; i++) {
            tabGroups[i].classList.remove('active');
          }

          for (var j=0; j<tabButtons.length; j++) {
            tabButtons[j].classList.remove('active');
          }

          clickedButtonGroup.classList.add('active');
          currentTab.classList.add('active');
        } else {
          const $ = window.jQuery;
          var textOrBackground = '';
          var slider = $('.mobile-slider').slick('getSlick');
          if (currentTab.classList.contains('text-edit')) {
            textOrBackground = 'text';
          } else if (currentTab.classList.contains('background-edit')) {
            textOrBackground = 'background';
          } else if (currentTab.classList.contains('image-edit')) {
            textOrBackground = 'image';
          }

          var tabs = document.querySelectorAll('.js-tab');
          for (var k=0; k<tabs.length; k++) {
            tabs[k].classList.remove('active');
          }


          currentTab.classList.add('active');

          var firstSlide = document.querySelector('[data-group="' + textOrBackground + '"]');
          var slickIndex = firstSlide.closest('.slick-slide').dataset.slickIndex;
          slider.slickGoTo(slickIndex);
        }
      },
      addLandscapeClickEvent: function() {
        function clickEvent(event) {
          var element = event.target.closest('.uyh-option-group');
          element.querySelector('.uyh-header').classList.toggle('open');
          element.querySelector('.uyh-select-group').classList.toggle('open');
        }

        function triggerAccordion() {
          var headers = document.querySelectorAll('.uyh-header');
          for (var l=0; l<headers.length; l++) {
            if (1024 <= window.innerWidth && window.innerWidth <= 1199) {
              headers[l].addEventListener("mouseup", clickEvent);
            } else {
              headers[l].removeEventListener("mouseup", clickEvent);
            }
          }
        }

        triggerAccordion();
        window.addEventListener('resize', triggerAccordion);
      },
      mobileSlider: function() {
        const $ = window.jQuery;
        var $this = this;
        var slickInited = false;

        function triggerMobileSlider() {
          if ( $('.mobile-slider').hasClass('slick-initialized') ) {
            slickInited = true;
          }

          if ($this.windowWidth <= 1023 && !slickInited) {
            window.slickChecker = setInterval($this.checkSlick, 50);
          }
        }

        triggerMobileSlider();
      },
      checkSlick: function() {
        let slider = document.querySelector('.mobile-slider')
        if (slider && slider.classList.contains('slick-initialized')) {
          clearInterval(window.slickChecker);
          window.slickChecker = undefined;
        } else {
          this.initSlick()
        }
      },
      initSlick: function() {
        const $ = window.jQuery;
        var next = $('.nextStep');
        var prev = $('.prevStep');
        var options = {
          arrows: true,
          dots: false,
          draggable: false,
          swipe: false,
          swipeToSlide: false,
          infinite: false,
          nextArrow: next,
          prevArrow: prev,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1
        };
        var slider = $('.mobile-slider').slick(options);
        slider.on('afterChange', function(slick, currentSlide){
          var slideIndex = currentSlide.currentSlide;
          var slides = currentSlide.$slides;
          var activeSlide = slides[slideIndex];
          var group = activeSlide.dataset.group;

          var tab = document.querySelector('.js-tab.' + group + '-edit');
          if (!tab.classList.contains('active')) {
            var tabs = document.querySelectorAll('.js-tab');
            for (var m=0; m<tabs.length; m++) {
              tabs[m].classList.remove('active');
            }
            tab.classList.add('active');
          }
        });
      }
    },
    mounted: function() {
      this.widowWidthFunction();
      window.addEventListener('resize', this.widowWidthFunction);

      this.$nextTick(function() {
        this.addLandscapeClickEvent();
        this.mobileSlider();
        window.addEventListener('resize', this.mobileSlider);
      });
    },
    updated: function() {
      this.$nextTick(function() {
        this.mobileSlider();
        window.addEventListener('resize', this.mobileSlider);
      });
    },
    computed: {
      getStore() {
        return {
          primarybackground: this.$store.state.primarybackground,
          secondarybackground: this.$store.state.secondarybackground,
          textareacolor: this.$store.state.textareacolor,
          textcolor: this.$store.state.textcolor,
          textstyle: this.$store.state.textstyle,
          textareaborder: this.$store.state.textareaborder,
          message: this.$store.state.message,
          hashtag: this.$store.state.hashtag,
          icon: this.$store.state.icon,
          options: this.$store.state.options
        }
      }
    },
    destroyed: function() {
      document.removeEventListener('resize', this.mobileSlider);
      document.removeEventListener('resize', this.widowWidthFunction);
      document.removeEventListener('resize', this.addLandscapeClickEvent.triggerAccordion);
    }
  }
</script>

<style lang="scss">
  .responsivesite #wrapper #uyh-app,
  #uyh-app {
    $mobile-breakpoint: 767px;
    $tablet-landscape-breakpoint: 1023px;
    $tablet-portrait-breakpoint: 1024px;
    $tablet-down-breakpoint: 1199px;
    $desktop-breakpoint: 1200px;
    $hd-desktop-breakpoint: 1280px;

    .image-editor-container {
      background-color: #e0e9e7;
      flex: 1 0 31.25%;
      text-align: center;
      width: 31.25%;
      .image-editor,
      .text-editor,
      .background-editor {
        display: none;
        &.active {
          display: block
        }
      }
    }

    .uyh-customize-header {
      padding: 36px 0 31px;
      p {
        font-size: 28px;
        line-height: 1;
        margin: 0;
      }
    }

    .uyh-edit-tabs {
      display: flex;
      flex-wrap: nowrap;
      .image-edit {
        padding: 6px 0;
        .box {
          border: 2px #223628 solid;
          display: block;
          height: 24px;
          margin: 0 auto;
          position: relative;
          width: calc(2 / 3 * 24px);
        }
      }

      .text-edit {
        font-size: 27px;
        line-height: 1;
        padding: 6px 0;
      }

      .background-edit {
        padding: 12px 0;
        .box {
          border: 2px #223628 solid;
          display: block;
          height: 18px;
          margin: 0 auto;
          position: relative;
          width: 24.5px;
        }
      }

      .text-edit,
      .background-edit,
      .image-edit {
        background-color: transparent;
        border: 1px solid #9b9b9b;
        flex: 1 0 calc(100% / 3);
        text-align: center;
        position: relative;
        width: calc(100% / 3);
        &.active {
          background-color: #ffffff;
          &::after,
          &::before {
            bottom: -1px;
            content: '';
            display: block;
            left: 50%;
            position: absolute;
            transform: translateX(-50%);
          }
          &::after {
            border-bottom: 6px solid #e0e9e7;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
          }
          &::before {
            border-bottom: 8px solid #9b9b9b;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
          }
        }
      }
    }

    .uyh-header {
      align-content: center;
      border-bottom: 1px #9b9b9b solid;
      display: flex;
      font-size: 18px;
      justify-content: space-between;
      margin: 0;
      padding: 12px 20px;
      p {
        font-size: 18px;
        margin: 0 auto;
        text-align: center;
      }
      button::after {
        display: none;
      }
      img {
        height: 15px;
        margin: 4px 0;
        width: auto;
        &.next {
          transform: rotate(180deg);
        }
        &.inactive {
          cursor: default;
          opacity: 0.6;
          pointer-events: none;
        }
      }

      &.collapsable {
        cursor: pointer;
        position: relative;
        &::before,
        &::after {
          content: '';
          background-color: #223628;
          display: block;
          height: 2px;
          position: absolute;
          top: 50%;
          transform: translateX(-50%);
          transition: transform 0.3s ease-in-out;
          right: 20px;
          width: 13px;
        }
        &::before {
          transform: rotate(90deg);
          right: 26.5px;
        }
        &.open {
          &::before {
            transform: rotate(0);
          }
        }
      }
    }

    .uyh-select-group {
      padding: 42px 0;
    }

    .uyh-option-group {
      border-bottom: 1px #9b9b9b solid;
      &:last-child {
        border-bottom: none;
      }
    }

    .uyh-button-group {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
    }

    .uyh-swatch-group {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      padding: 16px 39px;

      .uyh-swatch-wrapper {
        align-items: flex-start;
        display: flex;
        flex-wrap: wrap;
        margin: 0 auto;
        text-align: left;
        max-width: 201px;
      }
      .uyh-swatch {
        border: 1px solid #223628;
        flex: 0 0 auto;
        height: 32px;
        margin: 13.25px 4px;
        position: relative;
        width: 32px;
        -webkit-appearance: none;
        &::after {
          display: none;
        }
        &.active,
        &:hover {
          outline: 1px solid #223628;
          outline-offset: 3.5px;
        }
        &.active {
          &::after {
            background-color: #ffffff;
            border-radius: 100%;
            content: '';
            display: block;
            height: 5.5px;
            left: 50%;
            position: absolute;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
            width: 5.5px;
          }
        }
        &.break-swatch {
          margin: 13.25px 5px 13.25px 4px;
        }
      }
      .uyh-nested-button-group {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0 4px;
      }
    }

    .uyh-arrow-group {
      .arrow-button {
        background: transparent;
        border: none;
        font-size: 25px;
        line-height: 25px;
        margin: 0 7px;
        height: 25px;
        padding: 0;
        position: relative;
        width: 25px;
        &.image-up {
          top: -2px;
        }
        &:hover {
          background-color: #fc7ca0;
        }
        color: #223628;
      }
      .center {
        background-color: #223628;
        border-radius: 100%;
        display: inline-block;
        height: 21px;
        vertical-align: sub;
        width: 21px;
      }
    }

    .range-wrapper {
      justify-content: space-between;
      border: 1px solid #22372b;
      border-radius: 15px;
      display: flex;
      height: 35px;
      margin: 0 auto;
      position: relative;
      width: 56%;
      .scale-button {
        background-color: transparent;
        border: none;
        border-radius: 15px;
        color: #22372b;
        font-size: 23px;
        height: 33px;
        line-height: 33px;
        margin: 0 7.5px;
        width: 33px;
        padding: 0;
        &.minus {
          line-height: 0.9;
        }
      }
      input[type=range] {
        -webkit-appearance: none;
        background-color: transparent;
        width: 100%;
        padding: 0;
        margin: 9.5px 0;
      }
      input[type=range]:focus {
        outline: none;
      }
      input[type=range]::-webkit-slider-runnable-track {
        width: 100%;
        height: 1px;
        cursor: pointer;
        background: #223628;
        border-radius: 0px;
        border: 0px solid #223628;
      }
      input[type=range]::-webkit-slider-thumb {
        border: 0px solid #223628;
        height: 20px;
        width: 20px;
        border-radius: 20px;
        background: #223628;
        cursor: pointer;
        -webkit-appearance: none;
        margin-top: -9.5px;
      }
      input[type=range]:focus::-webkit-slider-runnable-track {
        background: #2c4634;
      }
      input[type=range]::-moz-range-track {
        width: 100%;
        height: 1px;
        cursor: pointer;
        background: #223628;
        border-radius: 0px;
        border: 0px solid #223628;
      }
      input[type=range]::-moz-range-thumb {
        border: 0px solid #223628;
        height: 20px;
        width: 20px;
        border-radius: 20px;
        background: #223628;
        cursor: pointer;
      }
      input[type=range]::-ms-track {
        width: 100%;
        height: 1px;
        cursor: pointer;
        background: transparent;
        border-color: transparent;
        color: transparent;
      }
      input[type=range]::-ms-fill-lower {
        background: #223628;
        border: 0px solid #223628;
        border-radius: 0px;
      }
      input[type=range]::-ms-fill-upper {
        background: #223628;
        border: 0px solid #223628;
        border-radius: 0px;
      }
      input[type=range]::-ms-thumb {
        border: 0px solid #223628;
        height: 20px;
        width: 20px;
        border-radius: 100%;
        background: #223628;
        cursor: pointer;
      }
      input[type=range]:focus::-ms-fill-lower {
        background: #223628;
      }
      input[type=range]:focus::-ms-fill-upper {
        background: #2c4634;
      }

    }

    .uyh-additional-controls {
      align-items: center;
      display: flex;
      justify-content: space-around;
      margin-top: 13px;
      > * {
        font-size: 20px;
        margin: 0 25px;
      }
      .resetMantra {
        cursor: pointer;
        font-size: 20px;
        &.disabled {
          pointer-events: none;
          opacity: 0.5;
        }
        &:after {
          background-color: #223628;
          content: '';
          display: block;
          height: 2px;
          position: relative;
          width: 100%;
        }
      }
    }

    @media screen and (min-width: 1024px) and (max-width: $hd-desktop-breakpoint) {
      .uyh-customize-header {
        margin: 0;
        padding: 16px 0 20px;
        p {
          font-size: 25px;
          line-height: normal;
        }
      }
      .uyh-edit-tabs {
        .text-edit,
        .background-edit,
        .image-edit {
          height: 40px;
        }
        .background-edit {
          padding: 10px 0;
        }
      }

      .uyh-header {
        padding: 8px 20px;
      }
      .uyh-button-group {
        padding: 29px 0 31px;
        .uyh-btn {
          &.small {
            height: 30px;
          }
        }
      }

      .uyh-range-group,
      .uyh-arrow-group {
        padding: 18.5px 0;
      }

      .uyh-select-group {
        padding: 18.5px 0 28px;
        .uyh-swatch-wrapper {
          .uyh-swatch {
            margin: 8.25px 4px;
          }
          .break-swatch {
            margin: 8.25px 4px 8.25px 5px;
          }
        }
      }
    }

    // Mobile
    @media screen and (max-width: $tablet-landscape-breakpoint) {
      .image-editor-container {
        flex: 1 0 100%;
        width: 100%;
        @media screen and (max-width: 1023px) {
          padding-bottom: 40px;
        }
      }

      .mobile-slider-wrapper {
        position: relative;
      }

      .prevStep,
      .nextStep {
        background: transparent;
        border: none;
        height: 44px;
        left: 0;
        margin: 0;
        padding: 12.5px;
        position: absolute;
        top: 0;
        width: 44px;
        &:hover {
          background-color: transparent;
        }
        &.slick-disabled {
          visibility: hidden;
        }
        svg {
          height: 100%;
          width: 100%;
          @media screen and (max-width: 1023px) {
            height: 60%;
            width: 60%;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            position: absolute;
          }
        }
      }
      .nextStep {
        left: initial;
        right: 0;
        transform: rotate(180deg);
      }

      .uyh-option-group {
        display: none;
        &.active {
          display: block;
        }

        .mobile-header {
          padding: 0 20px;
          p {
            line-height: 44px;
          }
        }

        .uyh-swatch-wrapper {
          max-width: none;
          width: 100%;
        }

        .uyh-swatch {
          margin: 13.25px 17px;
        }

        .uyh-swatch-group {
          .uyh-nested-button-group {
            justify-content: space-around;
            margin: 13.25px 0;
          }
        }

        .uyh-button-group {
          .editor-btn {
            margin: 0 15px;
          }
        }

        .uyh-select-group {
          padding: 29.25px 0;
          .uyh-swatch-wrapper {
            .uyh-swatch {
              margin: 0 17px;
            }
          }
        }

        &:last-child {
          border-bottom: 1px #9b9b9b solid;
        }
      }
      .mobile-slider {
        .uyh-option-group {
          display: block;
        }
      }
    }

    // Landscape tablet
    @media screen and (min-width: 1024px) and (max-width: 1199px) {
      .uyh-select-group {
        height: 0;
        padding: 0;
        overflow: hidden;
        &.open {
          height: initial;
          padding: 42px 0;
        }
      }
    }

    @media screen and (max-width: 767px) {
      .uyh-select-group {
        display: block;
        overflow-x: auto;
      }
    }
  }
</style>
